import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "v-horizontal" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("svg", {
    class: "v-hl-svg",
    viewBox: "0 0 24 24",
    "aria-label": "horizontal scroll area navigate to previous button"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M15.84 21.36a.748.748 0 0 1-.53-.22l-7.55-7.55a2.252 2.252 0 0 1 0-3.18l7.55-7.551a.75.75 0 1 1 1.06 1.06l-7.55 7.55a.751.751 0 0 0 0 1.061l7.55 7.55a.75.75 0 0 1-.53 1.28z" })
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("svg", {
    class: "v-hl-svg",
    viewBox: "0 0 24 24",
    "aria-label": "horizontal scroll area navigate to next button"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M7.63 21.14a.75.75 0 0 1 0-1.06l7.55-7.55a.751.751 0 0 0 0-1.06L7.63 3.92a.75.75 0 1 1 1.06-1.061l7.55 7.55a2.252 2.252 0 0 1 0 3.182l-7.55 7.55a.748.748 0 0 1-1.06 0z" })
], -1);
const _hoisted_4 = {
    key: 2,
    class: "dots"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_7 = [
    _hoisted_6
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.button && _ctx.hasPrev)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["v-hl-btn v-hl-btn-prev", { 'v-hl-btn-between': _ctx.buttonBetween }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.prev && _ctx.prev(...args)), ["stop"])),
                role: "button"
            }, [
                _renderSlot(_ctx.$slots, "btn-prev", {}, () => [
                    _hoisted_2
                ])
            ], 2))
            : _createCommentVNode("", true),
        (_ctx.button && _ctx.hasNext)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["v-hl-btn v-hl-btn-next", { 'v-hl-btn-between': _ctx.buttonBetween }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.next && _ctx.next(...args)), ["stop"])),
                role: "button"
            }, [
                _renderSlot(_ctx.$slots, "btn-next", {}, () => [
                    _hoisted_3
                ])
            ], 2))
            : _createCommentVNode("", true),
        (_ctx.showIndicators && _ctx.totalElements > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalElements, (i) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["dot", { current: i === _ctx.currentIndex + 1 }]),
                        key: i,
                        onClick: ($event) => (_ctx.onIndexClick(i - 1))
                    }, _hoisted_7, 10, _hoisted_5));
                }), 128))
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass(["v-hl-container", [{
                        'v-hl-responsive': _ctx.responsive,
                        'v-hl-scroll': _ctx.scroll,
                        'v-hl-snap-start': _ctx.snap === 'start',
                        'v-hl-snap-center': _ctx.snap === 'center',
                        'v-hl-snap-end': _ctx.snap === 'end'
                    }, _ctx.containerClass]]),
            ref: "container",
            onScrollPassive: _cache[2] || (_cache[2] =
                //@ts-ignore
                (...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 34)
    ]));
}
